import { createCacheWrapper } from '@utils/cache';
import { HOURS_TO_MS } from '@utils/constants';

const cache = createCacheWrapper({
  evictAfterMs: 1 * HOURS_TO_MS
});
function parseLocationData(path) {
  return cache(path, () => {
    const url = new URL(path, "http://localhost/");
    return {
      asPath: path,
      pathname: url.pathname,
      search: url.search,
      searchParams: new URLSearchParams(url.search),
      hash: url.hash
    };
  }).value;
}

export { parseLocationData };
//# sourceMappingURL=util.parse-location-data.js.map
